import { Injectable } from '@angular/core';
import { ObjectCacheService } from './icache-service';
import { ParamMap } from '../data-service/system-param-cache-define';
import { ParameterApi } from '../api-service/parameters/parameter-api';
import { EasyNotificationService } from '../easy-notification.service';
import { GpParaApi } from '../api-service/gp-para/gp-para-api';
import { NhiimiSetting } from 'src/app/system/clinic/models/nhiimiSetting';
import { ClinicApi } from '../api-service/clinic/clinic-api';
import { UserCache } from '../user-cache';
import { SpecialSameTreatDto, SpecialSameTreatRxDto } from '../api-service/val-addapp/special-sameTreat-dto';
import { TemporaryWorkApi } from '../api-service/val-addapp/temporaryWork-api';
import { PricingApi } from '../api-service/pricing/pricing-api';
import { HspidApi } from '../api-service/hspid/hspid-api';
import { Hspid } from '../api-service/hspid/hspid';
import { MedLackAreaApi } from '../api-service/medlackarea/medlackarea-api';
import { MedLackArea } from '../api-service/medlackarea/medlackarea';
import { ClinicSession, ClinicSessionApi } from '../api-service/clinic/clinic-session-api.service';
import { IValueTextPair, ValueTextPair } from 'src/app/shared/models/value-text-pair';
import { PostAreaAPI, PostAreaDto } from '../api-service/postarea-api';
import { DxOpt, RsOpt, RxOpt } from '../api-service/hist/hist-edit-option';
import { DosageDTO, HistApi, StatOpts } from '../api-service/hist/hist-api';
import { FullUser, UserApi } from '../api-service/user/user-api';
import { User } from 'src/app/system/user/models/user';
import { TherapistScheduleDto } from '../api-service/user/uesrSimpleInfo';
import { RegisterApi } from '../api-service/register/register-api';
import { ChiHistApi } from '../api-service/hist/chi-hist-api';
import { SystemCodeEditOption } from '../api-service/system-code/systemcode-api';

@Injectable({
  providedIn: 'root'
})

/**
 * 系統參數快取Service。
 * @implements {ICacheService<ParamType, Map<ParamType, any>>}
 */
export class ObjectCachedService extends ObjectCacheService<CacheObject> {

  protected notifyMsgOnUpdated: string = '暫存內容已變更…';
  protected notifyMsgOnReload: string = '已重載暫存內容'
  /**
   * 建構子，初始化服務。
   * @param {ParameterApi} parameterApi - 用於獲取參數的 API 服務。
   * @param {EasyNotificationService} notifyService - 用於顯示通知的服務。
   */
  constructor(private clinicApi: ClinicApi, 
    private priceApi:PricingApi,private hspidApi:HspidApi,private postAreaApi:PostAreaAPI,
    private MedLackAreaApi:MedLackAreaApi,private clinicSessionApi:ClinicSessionApi,
    private histApi:HistApi,private chiHistApi:ChiHistApi,
    private userApi:UserApi,private regApi:RegisterApi,
    private tempApi:TemporaryWorkApi,private notifyService: EasyNotificationService) {
    super(notifyService);
  }

  protected async getCacheObject<K extends keyof CacheObject>(keys: K[]): Promise<Map<K, CacheObject[K]>> {
    var m:Map<K , CacheObject[K]> = new Map();
    var clinicId= UserCache.getLoginClinicId();
    for(let k of keys){
      if(k=='NhiImi'){
        var o = await this.clinicApi.GetNHIIMISettingAsync(clinicId);
        m.set(k,o as any);
      }
      if(k =='SpecialSameTreat'){
        var sp = await this.tempApi.GetSpecialSameTreatAsync();
        m.set(k,sp as any);
      }
      if(k=='SpSameTreatRxs'){
        var spSTR = await this.priceApi.GetSpecialSameTreatRx();
        m.set(k,spSTR as any);
      }
      
      if(k =='HSPID'){
        var hspidQuery = Object.assign({}, { htype: '', pageSkip: '', pageSize: '' });
        var pageData = await this.hspidApi.GetHspidAllFromHist(hspidQuery);
        var data:Hspid[] = pageData.data;
        m.set(k,data as any);
      }

      if(k=='MedLackArea'){
        var medLackAreaData = await this.MedLackAreaApi.GetAll('ALL');
        m.set(k,medLackAreaData as any);
      }
      if(k=='ClinicSession'){
        var sitlist = await this.clinicSessionApi.GetAll(0);  
        m.set(k,sitlist as any);
      }
      if(k=='CityArea'){
        var postArea = await this.postAreaApi.GetCityArea2();  
        m.set(k,postArea as any);
      }

      if(k=='RxOpt'){
        var rxOpt:RxOpt[];
        if(UserCache.IsChineseMode()){
          rxOpt = await this.chiHistApi.GetChiRxOptions();
        }else{
          rxOpt = await this.histApi.GetRxOptions();
        }
        m.set(k,rxOpt as any);
      }
      if(k=='RsOpt'){
        var rsOpt = await this.histApi.GetRsOptions();
        m.set(k,rsOpt as any);
      }
      if(k =='DxOpt2014'){
        var d2014 = await this.histApi.GetDxOptions('2014');  
        m.set(k,d2014 as any);
      }
      if(k=='DxOpt2023'){
        var d2023 = await this.histApi.GetDxOptions('2023');
        m.set(k,d2023 as any);
      }
      if(k=='AllDxOpt'){
        var allDx = await this.histApi.GetAllDxOptions();
        m.set(k,allDx as any);
      }
      if(k=='Executor'){
        var executor = await this.histApi.GetExecutorList();  
        m.set(k,executor as any);
      }
      if(k=='CurrentUser'){
        var userData = await this.userApi.getFullUser(UserCache.getLoginUser().UserId);
        m.set(k,userData as any);
      }
      if(k=='Dosage'){
        var dosage = await this.histApi.GetDosages();
        m.set(k,dosage as any);
      }
      if(k=='StatOpt'){
        var statOpt = await this.histApi.GetStatOptions();
        m.set(k,statOpt as any);
      }
      if(k== 'RahbitUser'){
        var rahbitUsers = await this.regApi.GetRehabitMedUesrs(new Date(),true);
        m.set(k,rahbitUsers as any);
      }
      if(k=='TMDoctor'){
        var tmDoctor = await this.priceApi.GetTMDoctor();
        m.set(k,tmDoctor as any);
      }
      if(k=='STCMSingle'){
        var stcmSingle = await this.chiHistApi.GetSTCMSingle();
        m.set(k,stcmSingle as any);
      }
    }
    return m;
  }
}
export declare type CacheObject = {
  NhiImi:NhiimiSetting;
  SpecialSameTreat:SpecialSameTreatDto[];
  SpSameTreatRxs:SpecialSameTreatRxDto[];
  HSPID:Hspid[];
  MedLackArea:MedLackArea[],
  ClinicSession:ClinicSession[],
  CityArea:PostAreaDto;
  RxOpt: RxOpt[];
  RsOpt: RsOpt[];
  DxOpt2014: DxOpt[];
  DxOpt2023: DxOpt[];
  AllDxOpt: DxOpt[];
  StatOpt:StatOpts;
  Executor:IValueTextPair<string>[];
  SystemCodeOptions:SystemCodeEditOption;
  CurrentUser:FullUser;
  Dosage:DosageDTO[];
  RahbitUser:TherapistScheduleDto[];
  TMDoctor:ValueTextPair[];
  STCMSingle:string[];
}


